import { createContext, ReactNode, useContext } from "react";
import { StoreApi, useStore } from "zustand";

import { ContextOutOfBoundsError } from "providers/ContextOutOfBoundsError";

import { WorkflowEditorStoreState } from "./WorkflowEditor.store";

/**
 * TODOs

Frontend currently calculating outputs from result columns.

Keep/discard intermediates would be by column only then.... Any issues?

users can't delete columns so what happens if they don't discard a result then want to do it later.

We need more stable way for backend to return edges for input nodes.

Need to know whether output is intermediate

Sources that don't trace back to a table or to a table that is not selected...
- Sources that don't map become external sources
- Sources that map to a table that's not selected... Maybe external sources or can we warn a user that they're missing a table?
- NOT FOR NOW JUST MAKE THEM EXTERNAL INPUTS

Will need tool names, not currently available from tables

Param mapping uses tool specs params. Do we also want tool specs for other info to populate?

Do we want to display a list of actual result types in the output policy table or just the output column name?

What about compute resource selection? Do we want resource selectors for every step of the workflow on the workflow table itself?

Should we group workflow table at 3 levels? Tool level, table group level, and column level?

https://www.ag-grid.com/javascript-data-grid/column-groups/



display description for result cols
 */

const WorkflowEditorContext = createContext<
  StoreApi<WorkflowEditorStoreState> | undefined
>(undefined);

export const useWorkflowEditorContext = <T,>(
  selector: (state: WorkflowEditorStoreState) => T,
  equalityFn?: (a: T, b: T) => boolean,
) => {
  const store = useContext(WorkflowEditorContext);

  if (store === undefined) {
    throw new ContextOutOfBoundsError("WorkflowEditorContext");
  }
  return useStore(store, selector, equalityFn);
};

export interface WorkflowEditorProviderProps {
  children: ReactNode;
  store: StoreApi<WorkflowEditorStoreState>;
}

export const WorkflowEditorProvider = ({
  children,
  store,
}: WorkflowEditorProviderProps) => {
  return (
    <WorkflowEditorContext.Provider value={store}>
      {children}
    </WorkflowEditorContext.Provider>
  );
};
